/* JSQ PDP analytics v1 (2026-07-05) — audit §13. Scoped: bails unless .mp-page exists.
   Dispatches window CustomEvents and pushes to window.dataLayer when present.
   Add-to-cart is tracked as ATTEMPT only, once, via capture-phase form submit —
   the sticky bar routes through atc.click() so a separate hook would double-fire.
   No "success" event: not reliably detectable without coupling to cart JS. */
(function () {
  'use strict';
  var root = document.querySelector('.mp-page');
  if (!root) return;

  function track(name, detail) {
    var payload = Object.assign({ source: 'jsq-pdp' }, detail || {});
    try { window.dispatchEvent(new CustomEvent(name, { detail: payload })); } catch (e) {}
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
  }

  var base = {
    handle: root.getAttribute('data-product-handle') || '',
    productId: root.getAttribute('data-product-id') || '',
    price: parseInt(root.getAttribute('data-product-price'), 10) || 0
  };

  track('jsq_pdp_view', base);

  /* Delegated clicks — survives the related row being rewritten by /recommendations */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wa = t.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
    if (wa && root.contains(wa)) {
      track('jsq_pdp_whatsapp_click', Object.assign({ href: wa.getAttribute('href') }, base));
      return;
    }
    var rel = t.closest('[data-mp-reco-row] a, [data-mp-recent-row] a');
    if (rel) {
      track('jsq_pdp_related_click', Object.assign({
        href: rel.getAttribute('href'),
        list: t.closest('[data-mp-recent-row]') ? 'recently_viewed' : 'related'
      }, base));
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-mp-gift-toggle]')) {
      track('jsq_pdp_gift_toggle', Object.assign({ checked: !!t.checked }, base));
    }
    if (t.matches('[data-emboss-toggle]')) {
      track('jsq_pdp_personalization_toggle', Object.assign({ checked: !!t.checked }, base));
    }
  });

  var form = document.getElementById('mp-product-form');
  if (form) {
    form.addEventListener('submit', function () {
      track('jsq_pdp_add_to_cart_attempt', base);
    }, true);
  }
})();
